module.exports = __webpack_public_path__ + "assets/img/func3.53445976.png";